import { render, staticRenderFns } from "./ChoiceItemPriority.vue?vue&type=template&id=a9b9345c&scoped=true"
import script from "./ChoiceItemPriority.vue?vue&type=script&lang=js"
export * from "./ChoiceItemPriority.vue?vue&type=script&lang=js"
import style0 from "./ChoiceItemPriority.vue?vue&type=style&index=0&id=a9b9345c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b9345c",
  null
  
)

export default component.exports